import { locale } from "./globals.js";
import { loadHTML } from "./toolbox.js";
import { init as initCarousel } from "./image-carousel.js";
import { init as initVideo } from "./video-handler.js";
let shareLabel = locale.lang == 'en' ? 'Share' : 'شارك';

const popupDom = function(event) {
  return `
    <div class="popup-box event-details">
      <div class="popup-header image-carousel" data-image-carousel>${
        event.hero.innerHTML
      }</div>
      <div class="popup-content event-info">
        ${event.info.innerHTML}
      </div>
      <div class="popup-content event-content">
          <h1>${event.title.innerHTML}</h1>

          ${event.content.innerHTML}
          <div class="addthis-wrapper">
            <div class="addthis-toggle" role="button">
              <i class="far fa-share-alt icon open"></i>
              <i class="far fa-times icon close"></i>
            </div>
            <div class="addthis-label">
              ${shareLabel}
            </div>
            <div class="addthis_inline_share_toolbox" data-title="${event.title.innerHTML}" data-url="${event.url}" data-media="${event.media}"></div>
          </div>
          
          
      </div>
    </div>
    `;
};
class EventPopup {
  constructor(el) {
    if (!el) return false;
    if (el.hasAttribute("data-state")) return;
    this.el = el;
    this.href = this.getUrl();
    this.el.innerHTML +=
      '<div class="loading-spinner"><span class="icon"><i class="far fa-spinner fa-spin"></i></span></div>';
    this.setState("inited");
    this.el.addEventListener("click", event => {
      event.preventDefault();
      if (this.state == "loaded") {
        this.popup();
      } else {
        this.el.classList.add("loading");
        loadHTML(this.href, data => {
          this.response = data;
          this.parseResponse();
          this.el.classList.remove("loading");
          this.popup();
        });
      }
    });
  }
  getUrl() {
    let url = this.el.getAttribute("href");
    if (url.charAt(0) == "/") url = `${window.location.origin}${url}`;
    return url;
  }
  parseResponse() {
    this.event = {
      hero: this.response.querySelector(".page-cover"),
      title: this.response.querySelector(".page-header h1"),
      info: this.response.querySelector(".page-header .event-info"),
      content: this.response.querySelector(".page-content"),
      url: this.href,
      media: ''
    };
    let mediaElem = this.event.hero.querySelector('figure')
    if (mediaElem && mediaElem.hasAttribute('data-media')) {
      this.event.media = mediaElem.getAttribute('data-media')
    }
    //this.event.media = this.event.hero.querySelector('figure')
    console.log(this.event.media);
    this.setState("loaded");
  }
  popup() {
    $.fancybox.open({
      type: "html",
      content: popupDom(this.event),
      baseClass: "event-popup content-view",
      idleTime: false,
      video: {
        autoStart: false
      },
      afterShow: (instance, current) => {
        let carousel = current.$content[0].querySelector(
          "[data-image-carousel]"
        );
        let videos = Array.from(
          current.$content[0].querySelectorAll("[data-video-handler]")
        );
        addthis.layers.refresh()
        current.$content.find('.addthis-toggle').on('click', function() {
          $(this).toggleClass('show-tools');
        })

        initCarousel(carousel);
        if (videos && videos.length > 0) {
          videos.forEach(video => {
            initVideo(video);
          });
        }
      }
    });
  }
  setState(state) {
    this.state = state;
    this.el.setAttribute("data-state", state);
  }
}

export function initAll() {
  Array.from(document.querySelectorAll("[data-event-popup]")).forEach(
    (elem, index) => {
      init(elem);
    }
  );
}

export function init(elem) {
  if (elem.hasAttribute("data-status")) return;
  new EventPopup(elem);
}

export default function(elem) {
  if (!elem || elem.length < 1) {
    initAll();
  } else {
    init(elem);
  }
}
